import React from 'react';

export default function Icon({ name, className = '', style = {}, ...props }) {
  const ICONS = {
    ArrowRight:     'fa-solid fa-arrow-right',
    ArrowUp:        'fa-solid fa-arrow-up',
    ChevronRight:   'fa-solid fa-chevron-right',
    Home:           'fa-solid fa-house',
    Bars:           'fa-solid fa-bars',
    Times:          'fa-solid fa-xmark',
    Play:           'fa-solid fa-play',
    Search:         'fa-solid fa-magnifying-glass',
    Plus:           'fa-solid fa-plus',
    Trash:          'fa-solid fa-trash',
    Edit:           'fa-solid fa-pen-to-square',
    Save:           'fa-solid fa-floppy-disk',
    Undo:           'fa-solid fa-rotate-left',
    Link:           'fa-solid fa-link',
    Eye:            'fa-solid fa-eye',
    EyeSlash:       'fa-solid fa-eye-slash',
    ExternalLink:   'fa-solid fa-arrow-up-right-from-square',
    SignOut:        'fa-solid fa-right-from-bracket',
    CheckCircle:    'fa-solid fa-circle-check',
    Phone:          'fa-solid fa-phone',
    Envelope:       'fa-solid fa-envelope',
    EnvelopeOpen:   'fa-solid fa-envelope-open',
    MapMarker:      'fa-solid fa-location-dot',
    Clock:          'fa-solid fa-clock',
    Dashboard:      'fa-solid fa-gauge-high',
    Images:         'fa-solid fa-images',
    Image:          'fa-solid fa-image',
    FileAlt:        'fa-solid fa-file-lines',
    Cog:            'fa-solid fa-gear',
    Lock:           'fa-solid fa-lock',
    Lightbulb:      'fa-solid fa-lightbulb',
    Users:          'fa-solid fa-users',
    Trophy:         'fa-solid fa-trophy',
    Rocket:         'fa-solid fa-rocket',
    Palette:        'fa-solid fa-palette',
    Globe:          'fa-solid fa-globe',
    Github:         'fa-brands fa-github',
    Facebook:       'fa-brands fa-facebook-f',
    Instagram:      'fa-brands fa-instagram',
    Linkedin:       'fa-brands fa-linkedin-in',
    Twitter:        'fa-brands fa-x-twitter',
    Youtube:        'fa-brands fa-youtube',
    Meta:           'fa-brands fa-meta',
  };
  const faClass = ICONS[name] || 'fa-solid fa-circle-question';
  return <i className={`${faClass} ${className}`} style={style} aria-hidden="true" {...props} />;
}

export const FaArrowRight      = (p) => <Icon name="ArrowRight" {...p} />;
export const FaArrowUp         = (p) => <Icon name="ArrowUp" {...p} />;
export const FaChevronRight    = (p) => <Icon name="ChevronRight" {...p} />;
export const FaHome            = (p) => <Icon name="Home" {...p} />;
export const FaBars            = (p) => <Icon name="Bars" {...p} />;
export const FaTimes           = (p) => <Icon name="Times" {...p} />;
export const FaPlay            = (p) => <Icon name="Play" {...p} />;
export const FaSearch          = (p) => <Icon name="Search" {...p} />;
export const FaPlus            = (p) => <Icon name="Plus" {...p} />;
export const FaTrash           = (p) => <Icon name="Trash" {...p} />;
export const FaEdit            = (p) => <Icon name="Edit" {...p} />;
export const FaSave            = (p) => <Icon name="Save" {...p} />;
export const FaUndo            = (p) => <Icon name="Undo" {...p} />;
export const FaLink            = (p) => <Icon name="Link" {...p} />;
export const FaEye             = (p) => <Icon name="Eye" {...p} />;
export const FaEyeSlash        = (p) => <Icon name="EyeSlash" {...p} />;
export const FaExternalLinkAlt = (p) => <Icon name="ExternalLink" {...p} />;
export const FaSignOutAlt      = (p) => <Icon name="SignOut" {...p} />;
export const FaCheckCircle     = (p) => <Icon name="CheckCircle" {...p} />;
export const FaPhone           = (p) => <Icon name="Phone" {...p} />;
export const FaEnvelope        = (p) => <Icon name="Envelope" {...p} />;
export const FaEnvelopeOpen    = (p) => <Icon name="EnvelopeOpen" {...p} />;
export const FaMapMarkerAlt    = (p) => <Icon name="MapMarker" {...p} />;
export const FaClock           = (p) => <Icon name="Clock" {...p} />;
export const FaTachometerAlt   = (p) => <Icon name="Dashboard" {...p} />;
export const FaImages          = (p) => <Icon name="Images" {...p} />;
export const FaImage           = (p) => <Icon name="Image" {...p} />;
export const FaFileAlt         = (p) => <Icon name="FileAlt" {...p} />;
export const FaCog             = (p) => <Icon name="Cog" {...p} />;
export const FaLock            = (p) => <Icon name="Lock" {...p} />;
export const FaLightbulb       = (p) => <Icon name="Lightbulb" {...p} />;
export const FaUsers           = (p) => <Icon name="Users" {...p} />;
export const FaTrophy          = (p) => <Icon name="Trophy" {...p} />;
export const FaRocket          = (p) => <Icon name="Rocket" {...p} />;
export const FaPalette         = (p) => <Icon name="Palette" {...p} />;
export const FaGlobe           = (p) => <Icon name="Globe" {...p} />;
export const FaGithub          = (p) => <Icon name="Github" {...p} />;
export const FaFacebook        = (p) => <Icon name="Facebook" {...p} />;
export const FaInstagram       = (p) => <Icon name="Instagram" {...p} />;
export const FaLinkedin        = (p) => <Icon name="Linkedin" {...p} />;
export const FaTwitter         = (p) => <Icon name="Twitter" {...p} />;
export const FaYoutube         = (p) => <Icon name="Youtube" {...p} />;
export const FaMeta            = (p) => <Icon name="Meta" {...p} />;
